export default __webpack_public_path__ + "static/media/Icon awesome-star light.601d251f.svg";